module.exports = "/_next/static/resources/photo-4-abd1490a7f55c2ce046067425c54870a.webp";